import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'brand-visual-studio', 'BrandVisualStudio', [["path",{"d":"M4 8l2 -1l10 13l4 -2v-12l-4 -2l-10 13l-2 -1l0 -8","key":"svg-0"}]]);